<template>
  <div id="map" />
</template>

<script>
  /* eslint-disable */
  import 'leaflet/dist/leaflet.css';
  import 'leaflet';
  import 'leaflet-ajax/dist/leaflet.ajax.js';
  import 'leaflet-draw';
  import './leaflet.pattern';
  import PostcodeLayer from './leaflet.postcode-layer';
  import RadiusSelect from './leaflet.radius-select';
  import Key from './leaflet.key';

  export default {
    name: "CoverageMap",
    props: ['selectedRegions', 'initialAreas'],
    data: function() {
      return {
        map: null,
        postcodeLayer: null,
        radiusSelectRegions: new Set(),
        radiusDeselectRegions: new Set(),
        radiusSelectOngoing: false,
      }
    },
    mounted() {
      const highlighedColor = '#80b694';
      const deactiveColor = '#f1f5e5';
      const selectedColor = '#cadeca';
      const borderColor = '#bababa';
      const baseColor = '#f1f5e5';

      this.map = L.map('map', {
        minZoom: 6,
        attributionControl: false,
      }).setView([55.433649203872655,-3.426463146578598], 6);

      this.postcodeLayer = new PostcodeLayer({
        highlighedColor,
        deactiveColor,
        selectedColor,
        borderColor,
        baseColor,
        selectedRegions: this.selectedRegions,
        initialAreas: this.initialAreas,
      });
      this.postcodeLayer.addTo(this.map);
      this.postcodeLayer.updateInitialAreas(this.initialAreas);
      const key = new Key({values: [
          {text: this.$t('Not Selected'), color: baseColor},
          {
            text: this.$t('Partially Selected'),
            image: "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAA" +
              "AMb2lDQ1BEaXNwbGF5AABIiZVXd1STdxd+3pGEhBFGREGQsBFEkSVDZpiCgGxwEZIAYYT4kqDiHqWK1" +
              "i2iOCpad9FqBaQORK2zKG7r+HCgUqnFuiffHwnU2u983/nuOXl/99zfc5977/Pm5OQC/DaxUllIGgJF" +
              "ChWTGBkqTM/IFHIegAUCutADXywpUYYkJMQCQM/5d3t1FQQAXHIVK5WF/7z/r2YslZVIAGIMgGxpiaQ" +
              "IIJoAerZEyagAdhgA24kqpQpg5wEQMOkZmQB7KgBBrsZfAkCQrfE3AxAwyYkigN0A6OiJxUwuYHAcgL" +
              "BUkqsCDB4AcFNI5QqALwAQKMkTSwF+MoBBRUXFUoA/E4BTqSRXCfC3AfDJ/owz92/82b38YnFur6+ZC" +
              "wCgEyYvURaKJ/+f0vxvKypU99RwAKCXx0QlAhAAxPWC4phEAHoA0anIjosHYAwQb+RSje4AyctTR6Vo" +
              "8KSFpESUCcAUIN2k4rAYABYAGaEojIvVxrNz5BHRAAwBcpJcFZ2szZ0nKwlP0nKuZYoT43v8HEYUos2" +
              "tFTOAFn9cXZASouW/nieL7uF/UZaXnAaAB1C8UnlqHAADgBKUFCTFaDCUTVmeKK4Hw6gTUwDYAZSPTB" +
              "EZquGnxuQwEYlavLKopGdeqjxPHh2n9atUeclRGn2oHRJxeBKAfgBVJ1OEpPTwyErSY3tmkcrCwjWzU" +
              "y0yRYp2XuqOUhWaqM3tUhYmaPG0jqwwMhGADUCbl5QmaXPp4SomWfuO6FilKiFZ0yedlS8ekaDphy5F" +
              "LEQIgxBqCJGNYuRD3tJZ3wmh9iYCYjDIhQyu2khPRhrEYKCAGEkow+9QQIaS3rxQiMFAhlIo8LE3qnm" +
              "6IgdiMCiFDCUowEMwKEIMCiGDGgxkUPRWS8UDMJD/o7oExShEMRjI/0MsBCLEaiPqHl4hvwfJDmeHsa" +
              "PYEeyBtDkdSPvTsXQgHUwH0u60D+3b0+1feNZDVivrHusKq411Y7x8NvNFLyPRBrVWKRmyP5+YdqDda" +
              "S86lA6gA2lfCGlT2hyutCftQ4fQQbQ/7UX7QqTtWw3mC6W+mOAzzbU4rhuX5PblBnOdvsw0cDbw6mWR" +
              "QfE3fTS9ZveqKuq9+bK+6DOdpShGzJdIah61jzpJHaVOUwepegipI1QDdY46RNV/9h16AAa5vdUSIYM" +
              "CBSiE/B/1xNqaDGQocdvp1uH2QXsHlWySCgBExcrJjDw3TyUMUSoLZcJohWTwIKG7m7sbkJ6RKdT8TD" +
              "03BQGAMD3zV2wODwhQdHd3H/wrFvMO+NEa4LX9FXO8CBgogVNLJWqmVBOjAYAFHvgQwAwDYAsnuMId3" +
              "vBHMMIxAvFIRgbGQYI8FIHBREzFLJRjAZZgJdZgAzZhG77HXtTjII7iZ5zFBVzBTbShHU/QhVd4TxAE" +
              "h9AnTAgzwoqwJ1wId8KHCCTCiVgikcggsohcQkGoianEHGIBsYxYQ2wkthM/EAeIo8RpopW4QdwlOog" +
              "/iXckReqRAtKSdCCHkD5kCBlDJpNjyVxyAllGziUXkVVkDbmLrCOPkmfJK2Qb+YR8SYHSpUwpa8qV8q" +
              "FEVDyVSeVQDDWdqqAqqRqqlmqkTlKXqDaqk3pLs2kTWki70v50FJ1CS+gJ9HR6Ib2G3kbX0cfpS/Rdu" +
              "ov+xNJnWbBcWH6saFY6K5c1kVXOqmRtYe1nnWBdYbWzXrHZbFO2I3sYO4qdwc5nT2EvZK9j72Y3sVvZ" +
              "99kvORyOGceFE8CJ54g5Kk45ZzVnF+cI5yKnnfNGR1fHSsddJ0InU0ehM1unUmeHzmGdizqPdN5zDbn" +
              "2XD9uPFfKncxdzN3MbeSe57Zz3/OMeI68AF4yL583i1fFq+Wd4N3iPdfV1bXR9dUdpSvXnalbpbtH95" +
              "TuXd23esZ6znoivTF6ar1Felv1mvRu6D3X19d30A/Wz9RX6S/S365/TP+O/hsDE4PBBtEGUoMZBtUGd" +
              "QYXDZ7yuXx7fgh/HL+MX8nfxz/P7zTkGjoYigzFhtMNqw0PGF4zfGlkYjTUKN6oyGih0Q6j00aPjTnG" +
              "DsbhxlLjucabjI8Z3zehTGxNRCYSkzkmm01OmLQL2AJHQbQgX7BA8L2gRdDVx7iPZ5/UPpP6VPc51Kf" +
              "NlDJ1MI02LTRdbLrX9Krpu76WfUP6yvrO71vb92Lf1/369wvuJ+tX0W93vyv93pkJzcLNCsyWmtWb3T" +
              "anzZ3NR5lPNF9vfsK8s7+gv39/Sf+K/nv7/2pBWjhbJFpMsdhkcc7ipeUAy0hLpeVqy2OWnQNMBwQPy" +
              "B+wYsDhAR1WJlaBVnKrFVZHrH4T9hGGCAuFVcLjwi5rC+soa7X1RusW6/c2jjYpNrNtdtvctuXZ+tjm" +
              "2K6wbbbtsrOyG2k31W6n3a/2XHsf+zz7VfYn7V87ODqkOXztUO/w2LGfY7RjmeNOx1tO+k5BThOcapw" +
              "uD2QP9BlYMHDdwAvOpLOXc55ztfN5F9LF20Xuss6ldRBrkO8gxaCaQddc9VxDXEtdd7reHWw6OHbw7M" +
              "H1g58OsRuSOWTpkJNDPrl5uRW6bXa7OdR46Iihs4c2Dv3T3dld4l7tftlD3yPCY4ZHg8czTxdPmed6z" +
              "+teJl4jvb72avb66D3Mm/Gu9e4YZjcsa9jaYdd8BD4JPgt9TvmyfEN9Z/ge9H3r5+2n8tvr94e/q3+B" +
              "/w7/x8Mdh8uGbx5+P8AmQBywMaAtUBiYFfhtYFuQdZA4qCboXrBtsDR4S/CjkIEh+SG7Qp6GuoUyoft" +
              "DX4v8RNNETWFUWGRYRVhLuHF4Svia8DsRNhG5ETsjuiK9IqdENkWxomKilkZdi7aMlkRvj+4aMWzEtB" +
              "HHY/RikmLWxNyLdY5lYhtHkiNHjFw+8lacfZwirj4e8dHxy+NvJzgmTEj4aRR7VMKo6lEPE4cmTk08m" +
              "WSSND5pR9Kr5NDkxck3U5xS1CnNqfzUManbU1+nhaUtS2tLH5I+Lf1shnmGPKMhk5OZmrkl8+Xo8NEr" +
              "R7eP8RpTPubqWMexk8aeHmc+rnDcofH88eLx+7JYWWlZO7I+iOPFNeKX2dHZa7O7JCLJKskTabB0hbR" +
              "DFiBbJnuUE5CzLOdxbkDu8tyOvKC8yrxOuUi+Rv4sPyp/Q/7rgviCrQXdhWmFu4t0irKKDiiMFQWK48" +
              "UDiicVtypdlOXKtgl+E1ZO6GJimC0lRMnYkgaVQKVUnVM7qb9S3y0NLK0ufTMxdeK+SUaTFJPOTXaeP" +
              "H/yo7KIsu+m0FMkU5qnWk+dNfXutJBpG6cT07OnN8+wnTF3RvvMyJnbZvFmFcz6Zbbb7GWzX8xJm9M4" +
              "13LuzLn3v4r8ame5QTlTfu1r/683zKPnyee1zPeYv3r+pwppxZkFbgsqF3xYKFl45puh31R9070oZ1H" +
              "LYu/F65ewlyiWXF0atHTbMqNlZcvuLx+5vG6FcEXFihcrx688XelZuWEVb5V6VVtVbFXDarvVS1Z/WJ" +
              "O35kp1aPXutRZr5699vU667uL64PW1Gyw3LNjw7lv5t9c3Rm6sq3GoqdzE3lS66eHm1M0nv/P5bvsW8" +
              "y0Ltnzcqtjati1x2/Htw7Zv32GxY/FOcqd6Z8euMbsufB/2fUOta+3G3aa7F+zBHvWe337I+uHq3pi9" +
              "zft89tX+aP/j2v0m+yvqiLrJdV31efVtDRkNrQdGHGhu9G/c/9Pgn7YetD5YfajPocWHeYfnHu4+Unb" +
              "kZZOyqfNo7tH7zeObbx5LP3b5+KjjLSdiTpz6OeLnYydDTh45FXDq4Gm/0wfO+JypP+t9tu6c17n9v3" +
              "j9sr/Fu6Xu/LDzDRd8LzS2Dm89fDHo4tFLYZd+vhx9+eyVuCutV1OuXr825lrbden1xzcKbzz7tfTX9" +
              "zdn3mLdqrhteLvyjsWdmn8N/NfuNu+2Q3fD7p67l3Tv5n3J/ScPSh58aJ/7UP9h5SOrR9sfuz8+2BHR" +
              "ceG30b+1P1E+ed9Z/rvR72ufOj398Y/gP851pXe1P2Oedf+58LnZ860vPF80v0x4eedV0av3ryvemL3" +
              "Z9tbn7cl3ae8evZ/4gfOh6uPAj42fYj7d6i7q7laKGTEAgAJA5uQAf24F9DMAkwsAb7Rm5wMAEJo9Fd" +
              "D8B/nPvmYvBAB4A7UAEgGImoA9TYDDTEB/JpAAIDkYpIdH70drJTke7houPQZgvenufm4JcBqBj0x39" +
              "/t13d0fNwPUDaBpgmbXBAC2IfBtGADcWD52Jr4wzR762YxfngDp4eGJL89/A5q6iVhaOP+rAAAACXBI" +
              "WXMAABYlAAAWJQFJUiTwAAAFbGlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2l" +
              "uPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PS" +
              "JhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNi4wLWMwMDIgNzkuMTY0NDYwL" +
              "CAyMDIwLzA1LzEyLTE2OjA0OjE3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93" +
              "d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjp" +
              "hYm91dD0iIiB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyIgeG1sbnM6eG" +
              "1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL" +
              "2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90" +
              "b3Nob3AvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHh" +
              "tbG5zOnN0RXZ0PSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VFdmVudC" +
              "MiIGV4aWY6UGl4ZWxYRGltZW5zaW9uPSIzMTIiIGV4aWY6UGl4ZWxZRGltZW5zaW9uPSIzMDIiIGV4a" +
              "WY6VXNlckNvbW1lbnQ9IlNjcmVlbnNob3QiIHhtcDpDcmVhdGVEYXRlPSIyMDIwLTA4LTA1VDEwOjQ1" +
              "OjQ4KzAxOjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMC0wOC0wNVQxMDo0ODo0MSswMTowMCIgeG1wOk1" +
              "ldGFkYXRhRGF0ZT0iMjAyMC0wOC0wNVQxMDo0ODo0MSswMTowMCIgZGM6Zm9ybWF0PSJpbWFnZS9wbm" +
              "ciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJEaXNwbGF5IiB4b" +
              "XBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjE0NzI2Mzg1LTRiZDAtNDBjZS05ZTAyLWY0MTNiMWNiOGY2" +
              "MyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoxNDcyNjM4NS00YmQwLTQwY2UtOWUwMi1mNDEzYjF" +
              "jYjhmNjMiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDoxNDcyNjM4NS00YmQwLTQwY2" +
              "UtOWUwMi1mNDEzYjFjYjhmNjMiPiA8eG1wTU06SGlzdG9yeT4gPHJkZjpTZXE+IDxyZGY6bGkgc3RFd" +
              "nQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDoxNDcyNjM4NS00YmQwLTQw" +
              "Y2UtOWUwMi1mNDEzYjFjYjhmNjMiIHN0RXZ0OndoZW49IjIwMjAtMDgtMDVUMTA6NDg6NDErMDE6MDA" +
              "iIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4yIChNYWNpbnRvc2gpIiBzdE" +
              "V2dDpjaGFuZ2VkPSIvIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwd" +
              "Glvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pswjl3oAAABpSURB" +
              "VDiN7dWxDYAwDETRH+MKJTVi/3EYAwmUOlE6EgpG4Dq4AZ4s62SHPW8HENGkOrCKMIDkY/QCJBFY3Gw" +
              "SWU88zosWVE9oUg3w3i8tWFvWguoJ9Tv8e/g6H+yhh2CqWwiQHDgRvoAb/tYd39ZJ6x0AAAAASUVORK5CYII=')"
          },
          {text: this.$t('Selected'), color: selectedColor},
        ]});
      key.addTo(this.map);

      const radiusSelect = new RadiusSelect();
      this.map.on('areaOpened', ({region}) => {
        radiusSelect.addTo(this.map);
        this.$emit('areaOpened', region);
      });
      this.map.on('areaClosed', ({region}) => {
        radiusSelect.remove();
        this.$emit('areaClosed', region);
      });
      this.map.on('regionSelected', (layer) => {
        const name = layer.feature.properties.name;
        if (this.radiusSelectOngoing) {
          this.radiusSelectRegions.add(name);
          this.radiusDeselectRegions.delete(name);
        } else {
          this.$emit('outcodesSelected', [name]);
        }
      });
      this.map.on('regionDeselected', (layer) => {
        const name = layer.feature.properties.name;
        if (this.radiusSelectOngoing) {
          this.radiusSelectRegions.delete(name);
          this.radiusDeselectRegions.add(name);
        } else {
          this.$emit('outcodesDeselected', [name]);
        }
      });
      this.map.on('radiusSelectStarted', () => {
        this.radiusSelectRegions = new Set();
        this.radiusDeselectRegions = new Set();
        this.radiusSelectOngoing = true;
      });
      this.map.on('radiusSelectFinished', () => {
        this.$emit('outcodesSelected', Array.from(this.radiusSelectRegions))
        this.$nextTick(() => this.$emit('outcodesDeselected', Array.from(this.radiusDeselectRegions)));
        this.radiusSelectOngoing = false;
      });
      this.map.on('areaSelected', ({region}) => {
        this.$emit('areaSelected', region);
      });
      this.map.on('areaDeselected', ({region}) => {
        this.$emit('areaDeselected', region);
      });
    },
    methods: {
      onResize() {
        if (this.map) {
          this.map.invalidateSize();
        }
      }
    },
    watch : {
      selectedRegions(newVal, oldValue) {
        this.postcodeLayer.updateSelectedRegions(newVal);
      },
      initialAreas(val) {
        this.postcodeLayer.updateInitialAreas(val);
      }
    }
  }
</script>

<style lang="scss">
  .leaflet-right {
    .leaflet-control {
      margin-right: 10px;
      margin-top: 50px;
    }
  }

  #map {
    height: 100%;
    z-index: 0;
    min-height: 600px;
  }

  .leaflet-container {
    background-color: $white;
  }

  .leaflet-tooltip {
    box-shadow: none;
  }

  .leaflet-bar {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 1px solid $border-color;
  }

  .leaflet-control {
    font-size: 12px;
  }

  .radius-select-btn {
    background-image: url(data:image/svg+xml;base64,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);
    background-size: 20px;
  }

  .radius-select-marker {
    background-color: $white;
    border: 1px solid $white;
    border-radius: 50%;
    margin: -8px 0 0 -8px !important;
    width: 10px !important;
    height: 10px !important;
    outline: 0;
    transition: opacity ease .3s;
  }

  .regionTooltip {
    background: none;
    border: 0;
    -webkit-text-stroke: $white;
  }

</style>
